module.exports = __webpack_public_path__ + "static/media/trevor_chuna.7fa4ca4b.png";